import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-phase-navigation',
  templateUrl: './phase-navigation.component.html',
  styleUrls: ['./phase-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhaseNavigationComponent {
  @Input() public isReadOnly = false;
}
